/**
 * When a client has no stored color, pick a deterministic default from the app color scheme (same palette as projects).
 */
export function resolveClientDisplayColor(
	color: string | null | undefined,
	clientId: string,
	getColorFromScheme: (rnd?: number) => string
): string {
	if (color) return color;
	let h = 0;
	if (!clientId) return "#ffffff";
	for (let i = 0; i < clientId.length; i++) {
		h = (Math.imul(31, h) + clientId.charCodeAt(i)) | 0;
	}
	return getColorFromScheme(Math.abs(h) || 1);
}

export function resolveClientRefDisplayColor(
	client: { id?: string; color?: string | null } | null | undefined,
	getClientById: (id: string) => { color?: string | null } | undefined,
	getColorFromScheme: (rnd?: number) => string
): string {
	if (!client?.id) return resolveClientDisplayColor(null, "", getColorFromScheme);
	const stored = getClientById(client.id);
	return resolveClientDisplayColor(client.color ?? stored?.color, client.id, getColorFromScheme);
}
